import  {eXcell,__extends} from './eXcell';
import {dhx4} from '../../global/dhx4OrDhx';

var eXcell_tree = (function (_super) {
    __extends(eXcell_tree, _super);
    function eXcell_tree(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_tree.prototype.isDisabled = function () {
        return this.cell._disabled || this.grid._edtc;
    };
    eXcell_tree.prototype.edit = function () {
        if (this.er || this.grid._edtc) {
            return;
        }
        this.er = this.cell.parentNode.valTag;
        this.val = this.getLabel();
        this.cell.atag =
            !this.grid.multiLine && (dhx4.isKHTML || dhx4.isMacOS || dhx4.isFF)
                ? "INPUT"
                : "TEXTAREA";
        this.er.innerHTML =
            "<" +
                this.cell.atag +
                " class='dhx_combo_edit' type='text' style='height:" +
                (this.cell.offsetHeight - 4) +
                "px;line-height:" +
                (this.cell.offsetHeight - 6) +
                "px; width:100%; border:0px; margin:0px; padding:0px; overflow:hidden;'></" +
                this.cell.atag +
                ">";
        this.er.childNodes[0].onmousedown = function (c) {
            (c || event).cancelBubble = true;
        };
        this.er.childNodes[0].onselectstart = function (c) {
            if (!c) {
                c = event;
            }
            c.cancelBubble = true;
            return true;
        };
        this.er.className += " editable";
        this.er.firstChild.onclick = function (c) {
            (c || event).cancelBubble = true;
        };
        this.er.firstChild.value = this.val;
        this.obj = this.er.firstChild;
        this.er.firstChild.style.width =
            Math.max(0, this.cell.offsetWidth - this.er.offsetLeft - 2) + "px";
        this.er.firstChild.focus();
        if (dhx4.isIE) {
            this.er.firstChild.focus();
        }
    };
    eXcell_tree.prototype.getValue = function () {
        return this.getLabel();
    };
    eXcell_tree.prototype.setImage = function (c) {
        this.cell.parentNode.imgTag.nextSibling.src = this.grid.iconURL + c;
        this.grid._h2.get[this.cell.parentNode.idd].image = c;
    };
    eXcell_tree.prototype.setIcon = function (c) {
        this.grid._h2.get[this.cell.parentNode.idd].icon = c;
        this.cell.parentNode.imgTag.nextSibling.className =
            "dhx_treegrid_icon fa fa-" + c;
    };
    eXcell_tree.prototype.getImage = function () {
        return this.grid._h2.get[this.cell.parentNode.idd].image;
    };
    eXcell_tree.prototype.getIcon = function () {
        return this.grid._h2.get[this.cell.parentNode.idd].icon;
    };
    eXcell_tree.prototype.setLabel = function (c) {
        this.setValueA(c);
    };
    eXcell_tree.prototype.getLabel = function () {
        return this.cell.parentNode.valTag.innerHTML;
    };
    return eXcell_tree;
})(eXcell);
eXcell_tree.prototype.detach = function () {
    if (!this.er) {
        return;
    }
    this.setLabel(this.er.firstChild.value);
    this.er.className = this.er.className.replace("editable", "");
    var c = this.val != this.er.innerHTML;
    this.obj = this.er = null;
    return c;
};
eXcell_tree.prototype.setValueA = function (a) {
    this.cell.parentNode.valTag.innerHTML = a;
    this.grid.callEvent("onCellChanged", [
        this.cell.parentNode.idd,
        this.cell._cellIndex,
        a
    ]);
};
eXcell_tree.prototype.setValue = function (a) {
    this.grid.iconTree="";
    if (this.cell.parentNode.imgTag) {
        return this.setLabel(a);
    }
    var h = null;
    if (this.grid._tgc.iconTree == null ||
        this.grid._tgc.iconTree != this.grid.iconTree) {
        h = {};
        h.spacer =
            "<img src='" +
                this.grid.iconTree +
                "blank.gif'  align='top' class='space'>";
        h.imst = "<i  class='grid_collapse_icon " + this.grid.iconTree;
        h.imsti =
            "<i style='padding-top:2px;'  class='" +
                (this.grid.iconURL || this.grid.iconTree);
        h.imact =
            "' align='top' onclick='this." +
                (dhx4.isKHTML ? "" : "parentNode.") +
                "parentNode.parentNode.parentNode.parentNode.grid.doExpand(this);event.cancelBubble=true;'>";
        h.plus = h.imst + "plus.gif" + h.imact;
        h.minus = h.imst + "minus.gif" + h.imact;
        h.blank = h.imst + "blank.gif" + h.imact;
        h.start =
            "<div class='treegrid_cell' style='overflow:hidden; white-space : nowrap; line-height:23px; height:" +
                (dhx4.isIE ? 21 : 23) +
                "px;'>";
        h.itemim =
            "' align='top' " +
                (this.grid._img_height ? ' height="' + this.grid._img_height + '"' : "") +
                (this.grid._img_width ? ' width="' + this.grid._img_width + '"' : "") +
                " >";
        h.itemne = "<span id='nodeval'>";
        h.close = "</span></div>";
        this.grid._tgc = h;
    }
    // var l = this.grid._h2;
    h = this.grid._tgc;
    var g = this.cell.parentNode.idd;
    var m = this.grid._h2.get[g];
    if (this.grid.kidsXmlFile || this.grid._slowParse) {
        m.has_kids =
            m.has_kids || (this.cell.parentNode._attrs.xmlkids && m.state != "minus");
        m._xml_await = !!m.has_kids;
    }
    m.image = m.image || (this.cell._attrs.image || "goingicon go-formengine");
    m.icon =
        m.icon || (this.cell._attrs.icon || (this.grid.iconset ? "file-o" : ""));
    m.label = a;
    var e = [h.start];
    for (var c = 0; c < m.level; c++) {
        e.push(h.spacer);
    }
    if (m.has_kids) {
        e.push(h.plus);
        m.state = "plus";
    }
    else {
        e.push(h.imst + m.state + ".gif" + h.imact);
    }
    if (!m.icon) {
        e.push(h.imsti);
        e.push(m.image);
        e.push(h.itemim);
    }
    else {
        e.push("<i class='dhx_treegrid_icon fa fa-" + m.icon + "'></i>");
    }
    e.push(h.itemne);
    e.push(m.label);
    e.push(h.close);
    this.cell.innerHTML = e.join("");
    this.cell._treeCell = true;
    this.cell.parentNode.imgTag = this.cell.childNodes[0].childNodes[m.level];
    this.cell.parentNode.valTag = this.cell.childNodes[0].childNodes[m.level + 2];
    if (dhx4.isKHTML) {
        this.cell.vAlign = "top";
    }
    if (m.parent.id != 0 && m.parent.state == "plus") {
        this.grid._updateTGRState(m.parent, false);
        this.cell.parentNode._skipInsert = true;
    }
    this.grid.callEvent("onCellChanged", [g, this.cell._cellIndex, a]);
};
window.eXcell_tree = eXcell_tree;

export default eXcell_tree;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_tree.js